import { useEffect } from "react";
import { getTokenAndUpdateItems, initializeRsi } from "./RsiAuthService";
import { updateMeWithTenant } from "./api/UserApi";
import { getLoginSearchParams } from "../common/utils/SearchParams";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorCommon } from "../common/api/Api";
import { useTranslation } from "react-i18next";

/**
 * ログイン用のページコンポーネントです。
 * @returns ログイン用のページコンポーネント
 */
export const LoginPage = (): JSX.Element => {
  const { showBoundary } = useErrorBoundary();
  const { t } = useTranslation();

  const getRedirectPath = (state: string | null) => {
    if (state && state === "/app") {
      return "/app/serial";
    } else if (state) {
      return state;
    }
    return "/app";
  };

  useEffect(() => {
    (async () => {
      const loginParams = getLoginSearchParams(window.location.search);

      if (loginParams.error || !loginParams.code) {
        const errorMessage = `error=${loginParams.error}\ncode=${loginParams.code}`;
        showBoundary(errorMessage);
        return;
      }

      // ログイン後のリダイレクト
      const error = await getTokenAndUpdateItems(loginParams.code);
      if (error) {
        showBoundary(error);
        return;
      }

      initializeRsi();
      const result = await updateMeWithTenant();
      if (result.error) {
        return handleErrorCommon(result.error?.response?.data, result.error, showBoundary, t);
      }

      window.location.href = getRedirectPath(loginParams.state);
    })();
  }, []);

  return <div>{t("common.loginMessage")}</div>;
};
